import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Button from '../../../elements/Button';
import { ButtonProps } from '../../../elements/Button/Button';

interface Props {
  labelKey?: string;
  callToActionColor?: ButtonProps['color'];
  tabIndex?: boolean;
}

function CallToAction({
  tabIndex = true,
  labelKey = 'cmp-bus-directory-map-more-information',
  callToActionColor = 'link',
  style = {
    textDecoration: 'underline',
  },
  ...props
}: Omit<ButtonProps, 'color' | 'tabIndex'> & Props) {
  const { translate } = useContext(Context);

  return (
    <Button
      shadow="@theme:button.shadow"
      rounded="@theme:button.rounded"
      fontSize="3"
      paddingWidth="0"
      paddingHeight="0"
      style={style}
      {...props}
      className="call-to-action"
      color={callToActionColor}
      tabIndex={tabIndex ? undefined : -1}
      dataTestId="stationItemCallToAction"
    >
      {translate(labelKey, 'More information')}
    </Button>
  );
}

CallToAction.componentName = 'CallToAction';

export default CallToAction;
